/**
 * QL-f — a short, stable fingerprint of a saved Sumsub result.
 *
 * Used as part of the identity-conflict query key so the conflicts refetch
 * whenever the underlying result changes, whichever of the five writers changed
 * it. `searchedAt` plus the review answer is enough: a new scan always moves
 * one of them, and nothing else about the result can change what the document
 * attested.
 */
export function sumsubValueFingerprint(calculatedData?: string | null): string {
  if (!calculatedData) return "none";
  try {
    const parsed = JSON.parse(calculatedData) as {
      searchedAt?: string;
      status?: { reviewAnswer?: string | null };
    };
    return `${parsed.searchedAt ?? ""}:${parsed.status?.reviewAnswer ?? ""}`;
  } catch {
    return "invalid";
  }
}
